import React, { useState, useEffect } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';

const CityPage = () => {
  const [cities, setCities] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [formValues, setFormValues] = useState({
    name: '',
  });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10);  

  useEffect(() => {
    fetchCities(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const fetchCities = async (page = 1, search = '') => {
    try {
      setLoading(true);
      const res = await axios.get(`/admin/api/city?page=${page}&limit=${limit}&search=${search}`);
      const { cities = [], totalCount = 0 } = res.data;
      setCities(cities);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch Cities:', err);
      toastError('Failed to fetch cities');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const validationErrors = validateForm(formValues, {
      name: { required: true },
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setSaving(true);
      const payload = {
        name: formValues.name
      };

      if (editingId) {
        await axios.put(`/admin/api/city/${editingId}`, payload);
        toastSuccess('City updated successfully!');
      } else {
        await axios.post('/admin/api/city', payload);
        toastSuccess('City added successfully!');
      }
      setCurrentPage(1);
      fetchCities(1, searchQuery);
      handleCancel();
    } catch (err) {
      console.error('Failed to save City:', err);
      toastError(err.response?.data?.message || 'Failed to save City');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (city) => {
    setFormValues({
      name: city.name || '',
    });
    setEditingId(city._id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this city?')) {
      try {
        await axios.delete(`/admin/api/city/${id}`);
        toastSuccess('City deleted successfully!');
        setCurrentPage(1);
        fetchCities(1, searchQuery);
      } catch (err) {
        console.error('Failed to delete City:', err);
        toastError('Failed to delete City');
      }
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({ name: '' });
    setEditingId(null);
    setErrors({});
  };

  const handleViewCity = (city) => {
    setSelectedCity(city);
    setShowViewModal(true);
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0"> Cities</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search Cities..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">City List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Add New City
          </button>
        </div>

        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
            style={{ fontSize: '14px', lineHeight: '2' }}
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2">Name</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center py-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : cities.length > 0 ? (
                cities.map((city, idx) => (
                  <tr key={city._id}>
                    <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                    <td className="py-1 px-2">{city.name}</td>
                    <td className="py-1 px-2">
                      <button
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0"
                        style={{
          
                          color: '#C44C23',
                    
                        }}
                        title="Edit"
                        onClick={() => handleEdit(city)}
                      >
                        <FaEdit size={14} />
                      </button>
                      <button
                        className="btn btn-sm py-0 px-2 fs-6 lh-sm shadow-none border-0"
                        style={{
          
                          color: 'red',
                    
                        }}
                        title="Delete"
                        onClick={() => handleDelete(city._id)}
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-2">No Cities found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {(() => {
                const pages = [];
                const maxVisiblePages = 3;
                
                // Always show first page
                pages.push(
                  <button
                    key={1}
                    className="btn btn-sm"
                    style={{
                      backgroundColor: currentPage === 1 ? '#C44C23' : 'transparent',
                      color: currentPage === 1 ? 'white' : '#C44C23',
                      border: '1px solid #C44C23'
                    }}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>
                );

                // Show ellipsis if needed before current page range
                if (currentPage > maxVisiblePages + 1) {
                  pages.push(
                    <span key="ellipsis1" className="px-2">
                      ...
                    </span>
                  );
                }

                // Show pages around current page
                const startPage = Math.max(2, currentPage - 1);
                const endPage = Math.min(totalPages - 1, currentPage + 1);

                for (let page = startPage; page <= endPage; page++) {
                  if (page !== 1 && page !== totalPages) {
                    pages.push(
                      <button
                        key={page}
                        className="btn btn-sm"
                        style={{
                          backgroundColor: currentPage === page ? '#C44C23' : 'transparent',
                          color: currentPage === page ? 'white' : '#C44C23',
                          border: '1px solid #C44C23'
                        }}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    );
                  }
                }

                // Show ellipsis if needed after current page range
                if (currentPage < totalPages - maxVisiblePages) {
                  pages.push(
                    <span key="ellipsis2" className="px-2">
                      ...
                    </span>
                  );
                }

                // Always show last page if there's more than one page
                if (totalPages > 1) {
                  pages.push(
                    <button
                      key={totalPages}
                      className="btn btn-sm"
                      style={{
                        backgroundColor: currentPage === totalPages ? '#C44C23' : 'transparent',
                        color: currentPage === totalPages ? 'white' : '#C44C23',
                        border: '1px solid #C44C23'
                      }}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  );
                }

                return pages;
              })()}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>

      <CommonModalForm
        visible={showModal}
        title={editingId ? 'Edit City' : 'Add City'}
        fields={[
          { 
            name: 'name', 
            label: 'City Name', 
            type: 'text',
            placeholder: 'Enter City Name'
          },
        ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={saving ? (editingId ? 'Updating...' : 'Saving...') : (editingId ? 'Update' : 'Save')}
        requiredFields={['name']}
        disabled={saving}
      />

      {/* View City Modal */}
      {showViewModal && selectedCity && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">City Details</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowViewModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <p><strong>Name:</strong> {selectedCity.name}</p>
                  </div>
                  <div className="col-md-6">
                    <p><strong>Created:</strong> {new Date(selectedCity.createdAt).toLocaleDateString()}</p>
                  </div>
                  {selectedCity.updatedAt && (
                    <div className="col-md-6">
                      <p><strong>Updated:</strong> {new Date(selectedCity.updatedAt).toLocaleDateString()}</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowViewModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CityPage;
